import React from "react";
import { Send } from "lucide-react";

const inputClasses =
  "w-full border-b border-white/15 bg-transparent py-3 text-sm font-light text-ivory placeholder:text-stone/60 transition-colors duration-300 focus:border-gold focus:outline-none";

const Contact = () => {
  return (
    <section id="contact" className="mx-auto max-w-6xl px-6 py-20 sm:py-28 lg:py-36">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="text-xs font-light tracking-luxe uppercase text-gold">
            Private Inquiries
          </p>
          <h2 className="mt-6 font-display text-3xl font-medium leading-tight sm:text-5xl">
            Commission something singular.
          </h2>
          <p className="mt-8 max-w-md text-base font-light leading-relaxed text-stone">
            We accept a limited number of engagements each year. Tell us about
            your venture, and we will respond personally.
          </p>
        </div>
        <form
          action="https://formspree.io/f/mnqywkdl"
          method="POST"
          className="space-y-8"
        >
          <div className="grid gap-8 sm:grid-cols-2">
            <input
              type="text"
              name="name"
              required
              placeholder="Name"
              aria-label="Name"
              className={inputClasses}
            />
            <input
              type="email"
              name="_replyto"
              required
              placeholder="Email"
              aria-label="Email"
              className={inputClasses}
            />
          </div>
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            aria-label="Subject"
            className={inputClasses}
          />
          <textarea
            name="note"
            rows={4}
            placeholder="Tell us about your project"
            aria-label="Tell us about your project"
            className={`${inputClasses} resize-none`}
          />
          <button
            type="submit"
            className="group inline-flex items-center gap-3 border border-gold bg-gold px-8 py-3 text-xs font-medium tracking-[0.2em] uppercase text-ink transition-colors duration-300 hover:bg-transparent hover:text-gold"
          >
            Begin the Conversation
            <Send
              size={14}
              strokeWidth={1.5}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
